import React from 'react';
import { Card, Button, Form, Divider, Input, Row, Col } from 'antd';
import { MailOutlined, LockOutlined } from '@ant-design/icons';
import SetupCard from './SetupCard';
import { useTranslation } from 'react-i18next';

export default function SetupCompany({
  initialValues,
  step,
  pending,
  onChange,
  onDone,
}) {
  const [form] = Form.useForm();
  const { t } = useTranslation();

  const handleDone = () => {
    onDone(form.getFieldsValue());
  };

  return (
    <SetupCard step={step} pending={pending} onDone={handleDone}>
      <Form
        form={form}
        initialValues={initialValues}
        layout="vertical"
        name="setup-company-form"
        onValuesChange={onChange}
      >
        <Form.Item name="companyName" label={t('setup-company-name')}>
          <Input autoComplete={false} />
        </Form.Item>
        <Row gutter={12}>
          <Col span={12}>
            <Form.Item name="email" label={t('setup-company-email')}>
              <Input autoComplete={false} prefix={<MailOutlined />} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="password" label={t('setup-company-password')}>
              <Input.Password autoComplete={false} prefix={<LockOutlined />} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </SetupCard>
  );
}
